import { Button, VStack } from '@chakra-ui/react';
import { MdOutlineEdit, MdOutlineDeleteOutline, MdFileDownload, MdOutlinePhotoLibrary } from 'react-icons/md';

interface ReportActionsProps {
  canManage: boolean;
  onEdit: () => void;
  onDownload: () => void;
  isDownloading: boolean;
  onDownloadAttachments: () => void;
  isDownloadingAttachments: boolean;
  hasAttachments: boolean;
  onDelete: () => void;
}

// Same three actions that already existed in the page header (Modifica /
// Scarica PDF / Elimina) — this just gives them a sidebar-native layout.
// No new functionality, no new endpoints; the handlers are owned by the page.
export default function ReportActions({
  canManage,
  onEdit,
  onDownload,
  isDownloading,
  onDownloadAttachments,
  isDownloadingAttachments,
  hasAttachments,
  onDelete,
}: ReportActionsProps) {
  return (
    <VStack align="stretch" spacing={2}>
      {canManage && (
        <Button
          leftIcon={<MdOutlineEdit />}
          onClick={onEdit}
          justifyContent="flex-start"
          _hover={{ bg: 'gray.700' }} _active={{ bg: 'gray.600' }} _focus={{ boxShadow: 'none' }}
          backgroundColor="#688CC8" color="white" height="38px" borderRadius="6px" fontSize="sm"
        >
          Modifica rapporto
        </Button>
      )}
      <Button
        leftIcon={<MdFileDownload />}
        onClick={onDownload}
        isLoading={isDownloading}
        justifyContent="flex-start"
        variant="outline"
        borderColor="gray.300"
        _focus={{ boxShadow: 'none' }}
        height="38px" borderRadius="6px" fontSize="sm"
      >
        Scarica PDF
      </Button>
      {hasAttachments && (
        <Button
          leftIcon={<MdOutlinePhotoLibrary />}
          onClick={onDownloadAttachments}
          isLoading={isDownloadingAttachments}
          justifyContent="flex-start"
          variant="outline"
          borderColor="gray.300"
          _focus={{ boxShadow: 'none' }}
          height="38px" borderRadius="6px" fontSize="sm"
        >
          Scarica allegati
        </Button>
      )}
      {canManage && (
        <Button
          leftIcon={<MdOutlineDeleteOutline />}
          onClick={onDelete}
          justifyContent="flex-start"
          colorScheme="red"
          variant="outline"
          _focus={{ boxShadow: 'none' }}
          height="38px" borderRadius="6px" fontSize="sm"
        >
          Elimina rapporto
        </Button>
      )}
    </VStack>
  );
}
